(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-box-promo"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sf-box-promo')) {
    customElements.define('sf-box-promo', class extends HTMLElement {
      connectedCallback() {
        if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.classList.add('is-in');
          return;
        }
        this.classList.add('is-armed');
        const io = new IntersectionObserver((entries) => {
          if (entries.some((e) => e.isIntersecting)) { this.classList.add('is-in'); io.disconnect(); }
        }, { threshold: 0.3 });
        io.observe(this);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-buy-again"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sf-buy-again')) {
    class SfBuyAgain extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.addEventListener('change', (event) => this.onChange(event), { signal: this.controller.signal });
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      onChange(event) {
        const input = event.target;
        if (!(input instanceof HTMLInputElement) || input.name !== 'id') return;
        const images = this.querySelectorAll('.sf-again__img[data-variant-id]');
        const match = this.querySelector(`.sf-again__img[data-variant-id="${input.value}"]`);
        if (!match) return;
        images.forEach((img) => img.classList.toggle('is-hidden', img !== match));
      }
    }
    customElements.define('sf-buy-again', SfBuyAgain);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-catalog"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sf-quick-add')) {
    class SfQuickAdd extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.addEventListener('submit', (event) => this.onSubmit(event), { signal: this.controller.signal });
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      async onSubmit(event) {
        const form = event.target;
        const actions = window.Shopify?.actions;
        if (!(form instanceof HTMLFormElement) || !actions?.updateCart) return;
        event.preventDefault();
        const button = form.querySelector('button');
        const variantId = form.querySelector('input[name="id"]')?.value;
        if (!variantId || !button) return;
        const label = button.textContent;
        button.disabled = true;
        try {
          const result = await actions.updateCart(
            { lines: [{ merchandiseId: variantId, quantity: 1 }] },
            { event: { context: 'collection' } }
          );
          if (result?.userErrors?.length) throw new Error(result.userErrors[0].message);
          button.textContent = 'Added';
          await actions.openCart?.();
        } catch (error) {
          form.submit();
          return;
        } finally {
          button.disabled = false;
        }
        window.setTimeout(() => {
          button.textContent = label;
        }, 2500);
      }
    }
    customElements.define('sf-quick-add', SfQuickAdd);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-recipes"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sf-recipes')) {
    class SfRecipes extends HTMLElement {
      connectedCallback() {
        this.chips = [...this.querySelectorAll('[data-blend]')].filter((el) => el.tagName === 'BUTTON');
        this.items = [...this.querySelectorAll('.sf-recipes__item')];
        this.chips.forEach((chip) => chip.addEventListener('click', () => this.filter(chip.dataset.blend)));
      }

      filter(blend) {
        this.chips.forEach((c) => c.setAttribute('aria-pressed', String(c.dataset.blend === blend)));
        this.items.forEach((item) => {
          item.hidden = blend !== 'all' && item.dataset.blend !== blend;
        });
      }
    }
    customElements.define('sf-recipes', SfRecipes);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-store-locator"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sf-store-locator')) {
    class SfStoreLocator extends HTMLElement {
      connectedCallback() {
        this.items = [...this.querySelectorAll('[data-store]')];
        this.kind = 'all';
        this.origin = null;
        this.status = this.querySelector('[data-status]');
        this.querySelector('[data-search]').addEventListener('submit', (e) => {
          e.preventDefault();
          this.search(new FormData(e.target).get('q'));
        });
        this.querySelector('[data-near]').addEventListener('click', () => this.locate());
        this.querySelectorAll('[data-kind]').forEach((chip) => {
          if (chip.tagName !== 'BUTTON') return;
          chip.addEventListener('click', () => this.filter(chip.dataset.kind));
        });
        this.items.forEach((item) => {
          item.querySelector('[data-focus]').addEventListener('click', () => this.focusStore(item));
        });
        this.whenLeaflet(() => this.initMap());
      }

      whenLeaflet(cb, tries = 0) {
        if (window.L) return cb();
        if (tries > 100) return;
        setTimeout(() => this.whenLeaflet(cb, tries + 1), 100);
      }

      initMap() {
        const el = this.querySelector('[data-map]');
        this.map = L.map(el, { scrollWheelZoom: false, tap: true });
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          maxZoom: 19,
          attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        }).addTo(this.map);
        const icon = L.divIcon({
          className: 'sf-loc__pin',
          html: '<span></span>',
          iconSize: [28, 28],
          iconAnchor: [14, 28],
          popupAnchor: [0, -26],
        });
        this.items.forEach((item) => {
          const lat = parseFloat(item.dataset.lat);
          const lng = parseFloat(item.dataset.lng);
          if (Number.isNaN(lat) || Number.isNaN(lng)) return;
          const marker = L.marker([lat, lng], { icon, title: item.dataset.name }).addTo(this.map);
          marker.bindPopup(`<strong>${item.dataset.name}</strong><br>${item.dataset.address}`);
          marker.on('click', () => this.highlight(item));
          item._marker = marker;
        });
        this.fit();
      }

      visible() {
        return this.items.filter((i) => this.kind === 'all' || i.dataset.kind === this.kind);
      }

      fit() {
        if (!this.map) return;
        const pts = this.visible().filter((i) => i._marker).map((i) => i._marker.getLatLng());
        if (this.origin) pts.push(L.latLng(this.origin.lat, this.origin.lng));
        if (pts.length === 1) this.map.setView(pts[0], 13);
        else if (pts.length) this.map.fitBounds(L.latLngBounds(pts), { padding: [30, 30], maxZoom: 13 });
      }

      filter(kind) {
        this.kind = kind;
        this.querySelectorAll('button[data-kind]').forEach((c) => c.setAttribute('aria-pressed', String(c.dataset.kind === kind)));
        this.items.forEach((item) => {
          const show = kind === 'all' || item.dataset.kind === kind;
          item.hidden = !show;
          if (item._marker && this.map) {
            if (show) item._marker.addTo(this.map);
            else item._marker.remove();
          }
        });
        this.fit();
      }

      async search(query) {
        query = (query || '').trim();
        if (!query) return;
        this.say('Searching…');
        try {
          const url = `https://nominatim.openstreetmap.org/search?format=json&limit=1&countrycodes=us&q=${encodeURIComponent(query)}`;
          const res = await fetch(url, { headers: { 'Accept-Language': 'en' } });
          const data = await res.json();
          if (!data.length) return this.say(`We couldn't find "${query}". Try a ZIP code.`);
          this.setOrigin(parseFloat(data[0].lat), parseFloat(data[0].lon), query);
        } catch (e) {
          this.say('Search is unavailable right now. Browse the list below.');
        }
      }

      locate() {
        if (!navigator.geolocation) return this.say("Your browser can't share location. Try a ZIP code.");
        this.say('Finding you…');
        navigator.geolocation.getCurrentPosition(
          (pos) => this.setOrigin(pos.coords.latitude, pos.coords.longitude, 'you'),
          () => this.say('Location is off. Try a ZIP code instead.'),
          { timeout: 10000 }
        );
      }

      setOrigin(lat, lng, label) {
        this.origin = { lat, lng };
        const list = this.querySelector('[data-list]');
        this.items.forEach((item) => {
          const d = this.miles(lat, lng, parseFloat(item.dataset.lat), parseFloat(item.dataset.lng));
          item._dist = Number.isNaN(d) ? Infinity : d;
          item.querySelector('[data-dist]').textContent = Number.isFinite(item._dist) ? `${item._dist < 10 ? item._dist.toFixed(1) : Math.round(item._dist)} mi away` : '';
        });
        [...this.items].sort((a, b) => a._dist - b._dist).forEach((item) => list.appendChild(item));
        const nearest = this.visible().sort((a, b) => a._dist - b._dist)[0];
        this.say(nearest ? `Closest to ${label}: ${nearest.dataset.name}, ${nearest.querySelector('[data-dist]').textContent}.` : '');
        if (this.map) {
          if (this.you) this.you.remove();
          this.you = L.circleMarker([lat, lng], { radius: 8, color: '#111', weight: 3, fillColor: '#fff', fillOpacity: 1 }).addTo(this.map);
        }
        this.fit();
      }

      miles(lat1, lng1, lat2, lng2) {
        const r = (x) => (x * Math.PI) / 180;
        const dLat = r(lat2 - lat1);
        const dLng = r(lng2 - lng1);
        const a = Math.sin(dLat / 2) ** 2 + Math.cos(r(lat1)) * Math.cos(r(lat2)) * Math.sin(dLng / 2) ** 2;
        return 3958.8 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      }

      focusStore(item) {
        this.highlight(item);
        if (item._marker && this.map) {
          this.map.setView(item._marker.getLatLng(), 14);
          item._marker.openPopup();
          if (window.matchMedia('(max-width: 749px)').matches) {
            this.querySelector('[data-map]').scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
      }

      highlight(item) {
        this.items.forEach((i) => i.classList.toggle('is-active', i === item));
      }

      say(text) {
        this.status.textContent = text;
      }
    }
    customElements.define('sf-store-locator', SfStoreLocator);
  }

  } catch(e) { console.error(e); }
})();
})();
